export default __webpack_public_path__ + "static/media/Mask Group 12.c107b300.png";